define('collections/Podio.Collections.LinkedFiles',['require','lib/backbone/Backbone.PodioCachedCollection','lib/Podio.Routes','models/Podio.Models.LinkedFile'],function(require) {

  var PodioCachedCollection = require('lib/backbone/Backbone.PodioCachedCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCachedCollection.extend({

    configure: function() {
      this.model = require('models/Podio.Models.LinkedFile');
    },

    initialize: function(models, options) {

      this.linked_account_type = options.linked_account_type;
      this.linked_account_id = options.linked_account_id;
      this.external_folder_id = options.external_folder_id || 'all';
      this.parentMap = {};
      this.mime_types = [];

      this.regenerate_url();

      this._super();

      this.initCache(this.external_folder_id);
    },

    regenerate_url: function() {
      if (this.linked_account_type && this.linked_account_id) {
        this.url = routes.index_files_linked_account_path(this.linked_account_type, this.linked_account_id, {
          'external_folder_id' : this.external_folder_id,
          'mime_types' : this.mime_types
        });
      }

      this.setCacheKey(this.external_folder_id);
    }

  });

});



